import React, { useState, Children, Component } from 'react';
import { SearchIcon } from 'lucide-react';
const Hero = () => {
  const [destination, setDestination] = useState('');
  const [date, setDate] = useState('');
  const [guests, setGuests] = useState('1 Adult');
  const handleSearch = e => {
    e.preventDefault();
    // Create message for WhatsApp
    const message = `Hello, I'm interested in booking a trip to ${destination || 'your destinations'}.\n\nTravel Date: ${date || 'Flexible'}\nGuests: ${guests}\n\nPlease provide more information about available packages.`;
    // Open WhatsApp with the message
    window.open(`https://wa.me/96599886331?text=${encodeURIComponent(message)}`, '_blank');
  };
  return <div className="relative bg-gray-900 text-white" data-id="element-159">
      <div className="absolute inset-0 bg-cover bg-center opacity-40" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80")'
    }} data-id="element-160"></div>
      <div className="container mx-auto px-4 py-24 md:py-32 relative z-10" data-id="element-161">
        <div className="max-w-3xl" data-id="element-162">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-163">
            Discover the World with Forsa Co.
          </h1>
          <p className="text-xl mb-8" data-id="element-164">
            Experience unforgettable journeys with our expertly crafted travel
            packages
          </p>
          <form onSubmit={handleSearch} className="bg-white rounded-lg shadow-lg p-4 md:p-6 mt-8" data-id="element-165">
            <div className="flex flex-col md:flex-row md:items-end space-y-4 md:space-y-0 md:space-x-4" data-id="element-166">
              <div className="flex-1" data-id="element-167">
                <label className="block text-gray-700 text-sm font-medium mb-2" data-id="element-168">
                  Destination
                </label>
                <input type="text" placeholder="Where do you want to go?" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 text-gray-900" value={destination} onChange={e => setDestination(e.target.value)} data-id="element-169" />
              </div>
              <div className="flex-1" data-id="element-170">
                <label className="block text-gray-700 text-sm font-medium mb-2" data-id="element-171">
                  Date
                </label>
                <input type="date" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 text-gray-900" value={date} onChange={e => setDate(e.target.value)} data-id="element-172" />
              </div>
              <div className="flex-1" data-id="element-173">
                <label className="block text-gray-700 text-sm font-medium mb-2" data-id="element-174">
                  Guests
                </label>
                <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 text-gray-900" value={guests} onChange={e => setGuests(e.target.value)} data-id="element-175">
                  <option data-id="element-176">1 Adult</option>
                  <option data-id="element-177">2 Adults</option>
                  <option data-id="element-178">2 Adults, 1 Child</option>
                  <option data-id="element-179">2 Adults, 2 Children</option>
                  <option data-id="element-180">More</option>
                </select>
              </div>
              <button type="submit" className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-md flex items-center justify-center" data-id="element-181">
                <SearchIcon size={18} className="mr-2" data-id="element-182" />
                Search
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>;
};
export default Hero;